// Brand identifiers.
export default { LUXCAMP: 1, ALLCAMPS: 2 };



// WEBPACK FOOTER //
// ./src/variables/reviewBrandIdentifiers.js